import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { SelectComponent } from '../select/select.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectComponent],
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
})
export class LanguageSwitcherComponent {
  readonly #translocoService = inject(TranslocoService);

  readonly languages = signal(
    this.#translocoService.getAvailableLangs() as string[],
  );
  readonly activeLang = this.#translocoService.getActiveLang();

  setActiveLang(lang: string): void {
    this.#translocoService.setActiveLang(lang);
  }
}
